import type { FairuAsset } from '@src/lib/graphql/generated';
import { Image } from '@vgn-medien-holding/vgn-fe-components';

export interface AboutSheet {
  sheet_title: string;
  sheet_text: string;
  sheet_image: FairuAsset;
}
export interface AboutCardProps {
  cards: AboutSheet[];
  image?: FairuAsset;
}

export const AboutCard = ({ cards, image }: AboutCardProps) => {
  const offset = 80;
  return (
    <div className="relative border border-transparent">
      {image?.url && (
        <div className="relative mb-32 h-64 w-full">
          <Image
            src={image.url}
            alt={image.alt || ''}
            className="opacity-0 md:opacity-100"
            fill
            sizes="100vw"
            copyright={image.copyright_text || ''}
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
            <span className="mb-4 text-label-base">Das ist TV-Media</span>
            <span className="mb-4 max-w-3xl font-herokid text-heading-mobile-1 md:text-heading-1">
              Suche, entdecke und finde Filme und Serien von...
            </span>
          </div>
        </div>
      )}
      {cards.map((card, index) => (
        <div
          key={index}
          className={'min-h-[360px] overflow-hidden rounded-2xl border-gray-200 border-t bg-white lg:sticky'}
          style={{ top: `${offset * (index + 1)}px`, marginBottom: `${offset * (cards.length - index)}px` }}
        >
          <div className="z-10 flex items-center gap-8 px-18 py-6 font-medium text-black text-lg">
            <span className="font-herokid">{`0${index + 1}`}</span>
            <span className="font-bold text-xs uppercase tracking-2px">{card.sheet_title}</span>
          </div>
          <div className="flex flex-col justify-between bg-white px-6 pt-0 pb-18 lg:flex-row">
            <div className="basis-1/2 p-10">
              {card?.sheet_image?.url && (
                <div className="relative aspect-video size-full">
                  <Image
                    className="rounded-lg"
                    fill
                    src={card.sheet_image.url}
                    copyright={card?.sheet_title}
                    alt=""
                    sizes="(min-width: 992px) 50vw, 100vw"
                  />
                </div>
              )}
            </div>
            <div className="flex w-full items-center p-10 pt-0 lg:w-1/2">
              <div className="w-full focus:outline-none">
                {/* Extend touch target to entire panel */}
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="hyphenate font-bold font-herokid text-4xl text-black leading-header">
                  {card.sheet_title}
                </p>
                <div
                  className="mt-9 break-words text-black text-lg"
                  dangerouslySetInnerHTML={{ __html: card?.sheet_text }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
